<template>
  <div v-if="personData" class="mt-6 p-lg-6 p-3">
    <div
      v-if="personData.invitedMe.length > 0"
      class="dash-section p-3 mb-4"
    >
      <p>You were invited to join the company.</p>
      <button
        @click="emitStep('joinCompany')"
        class="btn btn-sm btn-primary"
      >
        {{ $t("common.welcome_screen.see_and_accept_invitation") }}
        <i class="fe fe-chevron-right ml-2"></i>
      </button>
    </div>
    <h3 class="text-secondary font-weight-light text-center">
      {{ $t("common.welcome_screen.join_in_or_create_new_workspace") }}
    </h3>
    <div class="row">
      <div class="col-md-6 d-flex">
        <button
          @click="emitStep('joinCompany')"
          class="btn btn-white mt-2"
        >
          <h4 class="font-weight-light mt-2">{{ $t("common.welcome_screen.join_existing_company") }}</h4>
          <span class="small text-muted">{{ $t("common.welcome_screen.need_to_ask_to_get_invitation") }}</span>
        </button>
      </div>
      <div class="col-md-6">
        <button
          @click="emitStep('createCompany')"
          class="btn btn-white mt-2"
        >
          <h4 class="font-weight-light mt-2">{{ $t("common.welcome_screen.create_new_workspace") }}</h4>
          <span class="small text-muted">{{ $t("common.welcome_screen.create_your_company_and_invite_your_team_members") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { AuthStepsMixin } from '../mixins/AuthStepsMixin';

  export default {
    name: 'SelectWorkspaceStep',
    mixins: [AuthStepsMixin],
  };
</script>

<style scoped>

</style>
